import request from "../plugins/request";

export const login = (params) => {
  return request({
    url: '/api/user/login',
    method: 'post',
    data: params
  })
}

